import { render, staticRenderFns } from "./scrapModal.vue?vue&type=template&id=5901484a"
import script from "./scrapModal.vue?vue&type=script&lang=js"
export * from "./scrapModal.vue?vue&type=script&lang=js"
import style0 from "./scrapModal.vue?vue&type=style&index=0&id=5901484a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports